import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/bak/users/')({
  component: () => <Navigate replace search to="/bo/users" />,
})
